'use client';

import { ReactNode } from 'react';

import Button from '@/components/FormFields/Button';
import cn from '@/helpers/utils/classNames';

interface ErrorButtonProps {
  children: ReactNode;
  className?: string;
  onClick: () => void;
}

const ErrorResetButton = ({ children, className, onClick }: ErrorButtonProps) => {
  return (
    <Button type="button" variant="filled" className={cn('', className)} scheme="primary" onClick={onClick}>
      {children}
    </Button>
  );
};

export default ErrorResetButton;
